




import Vue from 'vue'

export default Vue.extend({
  name: 'ElementNone',

  props: {
    templateItemData: {
      type: Object,
      required: true
    }
  }
})
